/*
 * Fast Track toggle — self-contained <fast-track-toggle> for the next-batch card.
 * Configurators call window.FastTrack.lineItem(scope, stamp) / .priceCents(scope) /
 * .reset(scope), and listen for the 'fasttrack:change' event to re-total.
 */
(function () {
  if (window.customElements && window.customElements.get('fast-track-toggle')) return;

  var SPIN_MS = 1000;

  class FastTrackToggle extends HTMLElement {
    connectedCallback() {
      // Re-fires on theme-editor re-insert; bail if already wired.
      if (this._initialized) return;
      this.input = this.querySelector('[data-pp-fast-track-toggle]');
      if (!this.input) return;
      this._initialized = true;

      this.switchEl = this.input.closest('.pp-fasttrack__switch');
      this.textEl = this.querySelector('[data-pp-fast-track-text]');

      this._onClick = this.onClick.bind(this);
      // Clicking the toggle or its label fires a click on the input.
      this.input.addEventListener('click', this._onClick);

      this.updateText();
    }

    disconnectedCallback() {
      if (this.input && this._onClick) this.input.removeEventListener('click', this._onClick);
      this._initialized = false;
    }

    // Cancel the native flip so we can run it behind a spinner instead. `_pending`     // guards against repeat taps landing mid-spin.
    onClick(e) {
      e.preventDefault();
      if (this._pending) return;
      this._pending = true;
      if (this.switchEl) this.switchEl.classList.add('is-loading');
      var self = this;
      setTimeout(function () {
        self.input.checked = !self.input.checked;
        self._pending = false;
        if (self.switchEl) self.switchEl.classList.remove('is-loading');
        self.updateText();
        self.notify();
      }, SPIN_MS);
    }

    // Let configurators (siblings, not ancestors) recalc their running total when
    // the toggle changes — the event bubbles up to document, where they listen.
    notify() {
      this.dispatchEvent(new CustomEvent('fasttrack:change', { bubbles: true }));
    }

    // Swap the description to match the toggle (on/off copy).
    updateText() {
      if (!this.textEl) return;
      var off = this.textEl.getAttribute('data-text-off') || '';
      var on = this.textEl.getAttribute('data-text-on') || '';
      this.textEl.textContent = this.input.checked ? on || off : off;
    }

    // The variant to add when the toggle is on, else null.
    get variantId() {
      if (!this.input || !this.input.checked) return null;
      var id = parseInt(this.input.getAttribute('data-pp-fast-track-variant'), 10);
      return id || null;
    }

    // Whether the toggle is currently on — drives the summary row's visibility
    // (shown even for a $0 Fast Track, like a free add-on).
    get isOn() {
      return !!(this.input && this.input.checked);
    }

    // The add-on price (cents) when the toggle is on, else 0 — for the summary.
    get priceCents() {
      if (!this.input || !this.input.checked) return 0;
      return parseInt(this.input.getAttribute('data-pp-fast-track-price'), 10) || 0;
    }

    // Switch off + restore the off copy (used by a configurator's "Make another").
    reset() {
      if (!this.input) return;
      this.input.checked = false;
      this._pending = false;
      if (this.switchEl) this.switchEl.classList.remove('is-loading');
      this.updateText();
    }
  }

  window.customElements.define('fast-track-toggle', FastTrackToggle);

  // Helper so a configurator's add-to-cart / reset stays two lines with no Fast   // Track specifics (variant lookup, cart-line shape, properties) leaking into it.
  window.FastTrack = window.FastTrack || {};

  window.FastTrack.el = function (scope) {
    return (scope || document).querySelector('fast-track-toggle');
  };

  // Build the Fast Track cart line for a section scope + the parent's link stamp, or null when the toggle is off / absent.
  window.FastTrack.lineItem = function (scope, stamp) {
    var el = window.FastTrack.el(scope);
    var variantId = el && el.variantId;
    if (!variantId) return null;
    return {
      id: variantId,
      quantity: 1,
      properties: { __linked_time: stamp, __fast_track_addon: 'true' }
    };
  };

  // Whether Fast Track is on in scope — drives the summary row's visibility.
  window.FastTrack.isOn = function (scope) {
    var el = window.FastTrack.el(scope);
    return !!(el && el.isOn);
  };

  window.FastTrack.isPending = function (scope) {
    var el = window.FastTrack.el(scope);
    return !!(el && el._pending);
  };

  // Fast Track price (cents) for the running-total summary; 0 when off / absent.
  window.FastTrack.priceCents = function (scope) {
    var el = window.FastTrack.el(scope);
    return el ? el.priceCents : 0;
  };

  // Switch the toggle off (no-op if there's no card in scope).
  window.FastTrack.reset = function (scope) {
    var el = window.FastTrack.el(scope);
    if (el && typeof el.reset === 'function') el.reset();
  };
})();
